import axios from "axios"; 

import { markSessionExpired } from "@session"; 
 
let interceptorRegistered = false; 

export const setupAxiosInterceptor = () => { 

  if (interceptorRegistered) return; 

  interceptorRegistered = true;

  axios.interceptors.response.use( (response) => response,(error) => { 
    console.log("error",error)
    console.log("error?.response",error?.response)
    const status = error?.response?.status; 

    const errorCode = error?.response?.data?.code; 

    const message = error?.response?.data?.message; 
    console.log("status",status)
    console.log("errorCode",errorCode)
    console.log("message",message)
    
    const isSessionExpired = (status === 401 &&  errorCode === "UNAUTHORIZED_ACCESS") || 

    errorCode === "TOKEN_EXPIRED" || 

    message === "Session expired";  

    if (isSessionExpired) { 

        markSessionExpired(); 

    } 

    return Promise.reject(error); 
    } 
  ); 
}; 